@if (bankAccountsLoaded()) {
  @if (displayAddBankAccountForm() || !hasBankAccountConnected()) {
    <mat-card>
      <mat-card-header>
        <mat-card-title>{{ 'BANK_ACCOUNT.ADD.TITLE' | translate }}</mat-card-title>
        <mat-card-subtitle>{{
          'BANK_ACCOUNT.ADD.PAYOUT_DESCRIPTION' | translate: { currency: currency$ | async }
        }}</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <smb-invoicing-add-bank-account-form
          [merchantCountry]="merchant()?.country"
          [addBankAccountError]="addBankAccountError()"
        >
        </smb-invoicing-add-bank-account-form>
      </mat-card-content>
      <mat-card-actions *ngIf="hasBankAccountConnected() || alwaysDisplaySaveButton()">
        <button mat-flat-button color="primary" (click)="create()" [disabled]="savingBankAccount()">
          <glxy-button-loading-indicator [isLoading]="savingBankAccount()">
            {{ 'BANK_ACCOUNT.ADD.SAVE_BANK_ACCOUNT_BUTTON' | translate }}
          </glxy-button-loading-indicator>
        </button>
        <button class="cancel-button" mat-button (click)="cancel()">
          {{ 'BANK_ACCOUNT.CANCEL_BUTTON' | translate }}
        </button>
      </mat-card-actions>
    </mat-card>
  } @else if (paymentStatus() === 'payments-configured') {
    <mat-card appearance="outlined">
      <mat-card-header>
        <mat-card-title>{{ 'BANK_ACCOUNT.TITLE' | translate }}</mat-card-title>
        <mat-card-subtitle>{{ 'BANK_ACCOUNT.SUBTITLE' | translate }}</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        @if (hasBankAccountConnected()) {
          <smb-invoicing-bank-account-list
            [bankAccounts]="bankAccounts()"
            (setDefaultBankAccount)="setDefault($event)"
            (deleteBankAccount)="delete($event)"
          ></smb-invoicing-bank-account-list>
        }
      </mat-card-content>
      <mat-card-actions>
        <button mat-flat-button color="primary" type="button" (click)="addBankAccount()">
          {{ 'BANK_ACCOUNT.ADD_BANK_ACCOUNT' | translate }}
        </button>
        @if (canViewPayouts() && hasBankAccountConnected()) {
          <a mat-stroked-button type="button" routerLink="/payouts">
            {{ 'BANK_ACCOUNT.VIEW_PAYOUTS' | translate }}
          </a>
        }
      </mat-card-actions>
    </mat-card>
  }
}
